import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { OrganizationDailySeriesResponse } from './types';

export async function getOrganizationDailySeries(organizationId: string) {
  const url = `/web/studio/organizations/${organizationId}/daily-series`;

  const response = await api.executeGetRequest<ObjectResponse<OrganizationDailySeriesResponse>>(url);

  return response.data;
}
